const COOKIE_NAME = 'shared_auth_token';

function getCookieDomain(): string {
  const hostname = window.location.hostname;
  if (hostname.includes('emercadohub.com')) {
    return '.emercadohub.com';
  }
  return ''; // localhost - no domain needed
}

export function setSharedAuthToken(customToken: string) {
  const domain = getCookieDomain();
  const domainPart = domain ? `; domain=${domain}` : '';
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  // 55 minutes - refresh before Firebase custom token expires (1 hour)
  document.cookie = `${COOKIE_NAME}=${customToken}; path=/${domainPart}; max-age=3300; SameSite=Lax${secure}`;
}

export function getSharedAuthToken(): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
  return match ? match[1] : null;
}

export function clearSharedAuthToken() {
  const domain = getCookieDomain();
  const domainPart = domain ? `; domain=${domain}` : '';
  document.cookie = `${COOKIE_NAME}=; path=/${domainPart}; max-age=0`;
}
